/**
 * Theme registry + persistence for SageMindLabs's switchable dark themes.
 * The choice is stored in localStorage and applied as a `data-theme` attribute
 * on <html>, which drives the CSS channel variables in index.css.
 */
export const THEMES = [
  {
    id: 'signal',
    name: 'Signal',
    tagline: 'Indigo · developer-grade',
    swatches: ['#0B0F1A', '#141A29', '#6366F1'],
    gradient: 'linear-gradient(120deg, #7C3AED, #22D3EE)',
  },
  {
    id: 'warm',
    name: 'Warm dark',
    tagline: 'Amber · cozy glow',
    swatches: ['#14110E', '#1F1B15', '#F59E0B'],
    gradient: 'linear-gradient(120deg, #FB7185, #F59E0B)',
  },
  {
    id: 'growth',
    name: 'Growth',
    tagline: 'Emerald · calm & trusted',
    swatches: ['#0A1014', '#101B20', '#10B981'],
    gradient: 'linear-gradient(120deg, #10B981, #14B8A6)',
  },
];

const STORAGE_KEY = 'sm-theme';
const DEFAULT_THEME = 'signal';
const VALID = new Set(THEMES.map((t) => t.id));

export function getTheme() {
  const t = localStorage.getItem(STORAGE_KEY);
  return VALID.has(t) ? t : DEFAULT_THEME;
}

export function applyTheme(id) {
  const theme = VALID.has(id) ? id : DEFAULT_THEME;
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(STORAGE_KEY, theme);
  return theme;
}

// Apply the saved theme immediately (called once at startup, before render).
export function initTheme() {
  document.documentElement.setAttribute('data-theme', getTheme());
}
